
export const TEXT_COLORS = [
	['red', '#ff2020'],
	['orange', '#ff7700'],
	['yellow', '#ffcb00'],
	['green', '#4eb31c'],
	['purple', '#7953e3'],
	['magenta', '#eb52f7'],
	['blue', '#05a2ef'],
	['gray', '#7e8386'],
];

export const HIGHLIGHT_COLORS = [
	['red', '#ff666680'],
	['orange', '#f1983780'],
	['yellow', '#ffd40080'],
	['green', '#5fb23680'],
	['purple', '#a28ae580'],
	['magenta', '#e56eee80'],
	['blue', '#2ea8e580'],
	['gray', '#aaaaaa80'],
];
